/**
 * isPriceValid Function
 *
 * This function checks if a given price is valid. A valid price is defined as a number
 * greater than 0 or a string that can be parsed into a number greater than 0.
 *
 * @param {number | null} price - The price to be validated. It can be a number, a string, or undefined.
 * 
 * @returns {boolean} - Returns true if the price is a number greater than 0 or a string 
 * that can be converted into a number greater than 0. Otherwise, returns false.
 *
 * Usage:
 * - isPriceValid(10); // returns true
 * - isPriceValid("$15.50"); // returns true
 * - isPriceValid("abc"); // returns false
 * - isPriceValid(-5); // returns false
 * - isPriceValid(undefined); // returns false
 */
export const isPriceValid = (price: number | string | null | undefined): boolean => {
  if (typeof price === 'number') {
    return price > 0;
  }
  if (typeof price === 'string') {
    // Remove dollar sign if present
    const sanitizedPrice = price.replace(/^\$/, '');
    const parsedPrice = parseFloat(sanitizedPrice);
    return !isNaN(parsedPrice) && parsedPrice > 0;
  }
  return false;
};
